<template>
  <aside
    class="h-screen fixed top-0 lg:border-r-0.5 lg:border-grey-11 dark:lg:border-dark-border transition-all duration-300 ease-in-out z-10 bg-white dark:bg-dark-surface hidden lg:block lg:w-80"
    role="complementary"
    aria-label="Main Navigation Loading"
  >
    <div class="px-2 lg:px-4 h-full lg:mt-12 flex flex-col">
      <!-- Navigation Controls Skeleton -->
      <nav aria-label="Navigation Controls">
        <ul class="pb-4 pt-4 lg:pt-0 flex items-center justify-between w-full">
          <!-- Expand/Collapse button skeleton -->
          <li class="ml-auto">
            <div class="skeleton-shimmer w-12 h-12 rounded-full"></div>
          </li>
        </ul>
      </nav>

      <!-- Navigation Items Skeleton -->
      <nav aria-label="Navigation Menu" class="relative overflow-hidden">
        <ul class="border-grey-7 dark:border-dark-border py-4 border-b-0.5 lg:border-y-0.5">
          <!-- Skeleton nav items -->
          <li
            v-for="i in 6"
            :key="i"
            class="skeleton-fade-in not-last:mb-2"
            :style="{ animationDelay: `${i * 0.05}s` }"
          >
            <div class="flex items-center py-2 px-4 rounded-full bg-grey-13 dark:bg-dark-surface-2">
              <div class="skeleton-shimmer w-6 h-6 rounded shrink-0"></div>
              <div class="skeleton-shimmer h-4 rounded ml-4 flex-1"></div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>
